import EventService from '@/services/api/EventService';

export default {
  state: {
    events: [],
    eventsInitialized: false,
    currentEventId: null,
  },

  mutations: {
    updateEvents(state, updatedEvents) {
      state.events = updatedEvents;
      state.eventsInitialized = true;
      window.eventBus.$emit('eventsInitialized');
    },

    updateCurrentEventTracks(state, { eventId, tracks }) {
      state.events
        .find(event => event.id === eventId)
        .playlist.tracks = tracks;
    },

    updateCurrentEventId(state, updatedCurrentEventId) {
      state.currentEventId = updatedCurrentEventId;
    },
  },

  actions: {
    fetchEvents({ commit }) {
      return new Promise((resolve, reject) => {
        EventService.fetchAll()
          .then(events => {
            commit('updateEvents', events);
            resolve(events);
          })
          .catch(error => reject(error));
      });
    },

    createEvent({ state, commit, dispatch }, eventData) {
      return new Promise((resolve, reject) => {
        dispatch('createSpotifyPlaylist', eventData.name)
          .then(playlistData => {
            // eslint-disable-next-line no-param-reassign
            eventData.spotify_playlist_id = playlistData.id;

            EventService.store(eventData)
              .then(data => {
                const events = [...state.events, data];
                commit('updateEvents', events);
                resolve(data);
              })
              .catch(error => {
                dispatch('rollbackPlaylist', playlistData.id);
                reject(error);
              });
          })
          .catch(error => reject(error));
      });
    },

    updateEvent({ state, commit, dispatch }, { eventId, eventData }) {
      return new Promise((resolve, reject) => {
        EventService.update(eventId, eventData)
          .then(event => {
            dispatch('updateSpotifyPlaylist', {
              playlistId: event.playlist.spotify_id,
              params: { name: event.playlist.name },
            });
            const events = state.events.slice();
            const index = events.findIndex(e => e.id === eventId);
            events.splice(index, 1, event);
            commit('updateEvents', events);
            resolve(event);
          })
          .catch(error => reject(error));
      });
    },

    deleteEvent({ state, commit }, eventId) {
      return new Promise((resolve, reject) => {
        EventService.delete(eventId)
          .then(event => {
            const events = state.events.slice();
            const index = events.findIndex(e => e.id === eventId);
            events.splice(index, 1);
            if (state.currentEventId === eventId) {
              commit('updateCurrentEventId', null);
            }
            commit('updateEvents', events);
            resolve(event);
          })
          .catch(error => reject(error));
      });
    },

  },

  getters: {
    events(state) {
      return state.events;
    },

    currentEvent(state) {
      if (state.events.length === 1 || !state.currentEventId) {
        return state.events[0];
      }

      return state.events.find(event => event.id === state.currentEventId);
    },

    eventsInitialized(state) {
      return state.eventsInitialized;
    },

    guestAccessToken(state, getters) {
      return getters.currentEvent.sub_user.token;
    },

  },
};
